/**
 * Normalize a backend list response into a flat array.
 *
 * Handles every format the .NET backend can produce:
 *  - PagedResult  { items, totalCount, … }        (new)
 *  - $values      { $id, $values: [...] }          (.NET ReferenceHandler.Preserve)
 *  - plain array  [...]
 *  - wrapper      { data: [...] }
 *
 * @param {*} response - Raw response from apiRequest()
 * @returns {Array} The items array
 */
export const extractItems = (response) => {
  if (!response) return [];

  // New PagedResult wrapper
  if (response.items !== undefined) {
    const raw = response.items;
    return Array.isArray(raw) ? raw : raw?.$values || [];
  }

  // .NET $values format
  if (response.$values) {
    return response.$values;
  }

  // Plain array
  if (Array.isArray(response)) {
    return response;
  }

  // Legacy { data: [...] } wrapper
  if (response.data) {
    const raw = response.data;
    return Array.isArray(raw) ? raw : raw?.$values || [];
  }

  return [];
};

/**
 * Extract both items and totalCount from a backend list response.
 *
 * @param {*} response - Raw response from apiRequest()
 * @returns {{ items: Array, totalCount: number }}
 */
export const extractPagedResponse = (response) => {
  const items = extractItems(response);
  const totalCount =
    response?.totalCount ?? response?.total ?? items.length;
  return { items, totalCount };
};
